function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.417 11a1.833 1.833 0 11-3.667 0 1.833 1.833 0 013.667 0zM11 12.833a1.833 1.833 0 100-3.666 1.833 1.833 0 000 3.666zm6.417 0a1.833 1.833 0 100-3.666 1.833 1.833 0 000 3.666z"
});

var SvgHorizontalPoints = function SvgHorizontalPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _ref);
};

export default SvgHorizontalPoints;